import { RougeDataSets } from "@project-rouge/rg-core";
import { getLevelConfig } from "@project-rouge/rg-three";
const GetLevelConfig = (dataSetVersion) => getLevelConfig(RougeDataSets[dataSetVersion]);
export { GetLevelConfig };

//# sourceMappingURL=index224.js.map